export type SeedanceDraftFamily = "2.5" | "1.5pro"

export type DraftFinalizeReason = "missing_task" | "expired" | "in_progress" | "wrong_account"

export type DraftFinalize = {
  available: boolean
  reason: DraftFinalizeReason | null
  message: string | null
  expires_at: string | null
  resolutions: string[]
  duration_sec: number | null
  model_key: string
  generate_audio: boolean
}

export function seedanceDraftFamily(modelKey: string | null | undefined): SeedanceDraftFamily | null {
  const key = modelKey?.toString() ?? ""
  if (/seedance-2[.-]5/i.test(key)) return "2.5"
  if (/seedance-1-5-pro/i.test(key)) return "1.5pro"
  return null
}

export function seedanceDraftEligible(
  modelKey: string | null | undefined,
  resolution: string | null | undefined,
): boolean {
  return resolution === "480p" && seedanceDraftFamily(modelKey) != null
}

export function parseDraftFinalize(raw: unknown): DraftFinalize | null {
  if (!raw || typeof raw !== "object") return null
  const row = raw as Record<string, unknown>
  const resolutions = Array.isArray(row.resolutions) ? row.resolutions.map(String) : []
  if (resolutions.length === 0) return null
  const reason = row.reason
  return {
    available: row.available === true,
    reason:
      reason === "missing_task" || reason === "expired" || reason === "in_progress" || reason === "wrong_account"
        ? reason
        : null,
    message: typeof row.message === "string" ? row.message : null,
    expires_at: typeof row.expires_at === "string" ? row.expires_at : null,
    resolutions,
    duration_sec: typeof row.duration_sec === "number" ? row.duration_sec : null,
    model_key: typeof row.model_key === "string" ? row.model_key : "",
    generate_audio: row.generate_audio === true,
  }
}

export function draftDaysLeft(expiresAt: string | null | undefined, now = Date.now()): number | null {
  if (!expiresAt) return null
  const ms = Date.parse(expiresAt) - now
  if (!Number.isFinite(ms)) return null
  if (ms <= 0) return 0
  return Math.ceil(ms / 86_400_000)
}

export function draftFinalizeButtonKey(finalize: DraftFinalize): "to1080p" | "finalize" {
  return finalize.resolutions.length === 1 && finalize.resolutions[0] === "1080p" ? "to1080p" : "finalize"
}
